import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { PAYMENT_PLAN_IFRAME } from './BuyNowPayLater.const';

export type PlanIframeProps = {
  onLoaded: (display: boolean) => void;
  price: number;
  display: boolean;
};

type Props = {
  paymentPlans: $ReadOnlyArray<Plan>;
  price: number;
  onLoaded: (plan: { id: string; display: boolean }) => void;
  displayIframe: boolean;
};

export const BuyNowPayLater = ({ paymentPlans, price, displayIframe, ...props }: Props) => {
  const formik = useFormikContext();

  useEffect(() => {
    paymentPlans.map(
      ({ value: id }) => !PAYMENT_PLAN_IFRAME[id] && props.onLoaded({ id, display: false }),
    );
  }, []);

  return paymentPlans.map(({ value: id }) => {
    const PlanIframe = PAYMENT_PLAN_IFRAME[id];
    const onPaymentPlanLoaded = (display: boolean) => props.onLoaded({ id, display });
    return (
      PlanIframe && (
        <PlanIframe
          key={id}
          onLoaded={onPaymentPlanLoaded}
          price={price}
          display={displayIframe && formik.values.paymentProviderId === id}
        />
      )
    );
  });
};
